import React, { memo, useState } from 'react'
import {
  InvestmentOption,
  ToggleWrapper,
} from 'src/components/Investment/Matured/maturedStyle'
import { All } from 'src/components/TargetSavings/Components/All'
import { Completed } from 'src/components/TargetSavings/Components/Completed'
import { Ongoing } from 'src/components/TargetSavings/Components/Ongoing'

interface TabProps {
  activeTab?: string
  tabs?: Array<{ key: string; name: string; component?: React.ReactNode }>
  setActiveTab?: (key: any) => void
}

const TabComponent: React.FC<TabProps> = ({
  tabs,
  activeTab,
  setActiveTab,
}) => {
  return (
    <ToggleWrapper className="wrap">
      <div className="wrap">
        {tabs?.map((tab) => {
          return (
            <p
              key={tab.key}
              className={activeTab === tab.key ? 'btn active-btn' : 'btn'}
              onClick={() => setActiveTab?.(tab.key)}
            >
              {tab.name}
            </p>
          )
        })}
      </div>
    </ToggleWrapper>
  )
}

export default memo(TabComponent)
